import { render, staticRenderFns } from "./ChooseSystem.vue?vue&type=template&id=038d5b80&scoped=true&"
import script from "./ChooseSystem.vue?vue&type=script&lang=js&"
export * from "./ChooseSystem.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSystem.vue?vue&type=style&index=0&id=038d5b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d5b80",
  null
  
)

export default component.exports